
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"49","height":"48"}},[_c('path',{attrs:{"d":"M28.5 16a4 4 0 00-4-4M12.5 16a12 12 0 0124 0c0 9.94-5.372 18-12 18s-12-8.06-12-18zM24.5 34v2a4 4 0 01-4 4h-6a4 4 0 00-4 4","stroke":"#161E2F","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#C0C2C7","d":"M.5 0h48v48H.5z"}})])])
          )
        }
      }
    